import classNames from "classnames";
import { useAppSelector } from "hooks/redux";
import { websiteBuilderGenerateLogoDesignStyles, IWebsiteBuilderLogo } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderLogo";
import React from "react";

interface IWebsiteBuilderLogoViewProps {
  node: IWebsiteBuilderLogo;
}

export function WebsiteBuilderLogoView(props: IWebsiteBuilderLogoViewProps) {
  const { node } = props;

  const logoUrl = useAppSelector(store => store.websiteBuilderStore.config.website?.logo_url);

  const settings = node.element.settings;
  const designStyles = websiteBuilderGenerateLogoDesignStyles(settings, logoUrl);

  return (
    <div className={designStyles.containerClassName}>
      {logoUrl && (
        <img
          className={classNames(designStyles.className, "editor-logo")}
          style={designStyles.styleProperties}
          src={logoUrl}
          alt={settings.alt}
        />
      )}
    </div>
  );
}
